<script lang="ts" module>
  import type { LinkLoginButtonProps } from '@/ui/elements/buttons/LinkLoginButton.svelte';
  import DropDownLogin from '@/ui/elements/dropdown/DropDownLogin.svelte';
  import type { DropDownLoginItem } from '@/ui/elements/dropdown/DropDownLogin/DropDownLoginSelect.svelte';
  import LoginCard from '@/ui/elements/login/LoginCard.svelte';
  import InputLogin, {
    isValidEmail,
    isValidPassword,
  } from '@/ui/elements/text-input/TextInput.svelte';

  import type { LoginState, UserSelectType } from '../LoginElement.svelte';
  import { useAuth } from '../use-auth.svelte';

  export interface LoginGeneralProps {
    loginState: LoginState;
    userSelectType: UserSelectType;
    userItems: DropDownLoginItem[];
  }
</script>

<script lang="ts">
  let [authState, { logIn }] = useAuth();
  let {
    loginState = $bindable(),
    userSelectType = 'email',
    userItems: items,
  }: LoginGeneralProps = $props();

  let mailError: string | undefined = $state(undefined);
  let passwordError: string | undefined = $state(undefined);
  let currentUserInput: 'email' | 'dropdown' = $state(
    userSelectType == 'both' ? 'email' : userSelectType,
  );

  let preLink: LinkLoginButtonProps | undefined = $derived(
    userSelectType == 'both' ?
      {
        label: currentUserInput == 'email' ? 'Benutzer wählen' : 'E-Mail eingeben',
        target: () => {
          currentUserInput = currentUserInput == 'email' ? 'dropdown' : 'email';
        },
      }
    : undefined,
  );

  const validate = () => {
    let returnState = true;

    let res = isValidEmail(loginState.userName);
    returnState = returnState && res.result;
    mailError = res.errorMsg;

    res = isValidPassword(loginState.password);
    returnState = returnState && res.result;
    passwordError = res.errorMsg;

    return returnState;
  };

  const onSubmit = () => {
    logIn(loginState.userName, loginState.password);
    loginState.password = '';
    if (authState.current.error) passwordError = 'Das Passwort wurde falsch angegeben.';
    else passwordError = '';
  };
</script>

<LoginCard
  headline="Herzlich Willkommen"
  text="Bitte loggen Sie sich ein:"
  ctaLabel="Log in"
  postLink={{
    label: 'Passwort vergessen?',
    target: () => {
      loginState.mainPage = 'loginGeneral';
      loginState.state = 'loginResetPass';
    },
  }}
  {preLink}
  {validate}
  {onSubmit}
>
  <div class="flex justify-center">
    {#if currentUserInput === 'dropdown'}
      <DropDownLogin
        label="Benutzer auswählen"
        bind:selected={loginState.userName}
        {items}
        errorMsg={mailError}
      ></DropDownLogin>
    {:else}
      <InputLogin
        label="E-Mail Adresse"
        type="text"
        id="login-email"
        bind:value={loginState.userName}
        errorMsg={mailError}
      ></InputLogin>
    {/if}
  </div>
  <div class="flex justify-center">
    <InputLogin
      label="Passwort"
      type="password"
      id="login-password"
      bind:value={loginState.password}
      errorMsg={passwordError}
    ></InputLogin>
  </div>
</LoginCard>
